import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'app'

import { PostHogProvider } from 'posthog-js/react'
import { postHogOptions } from 'shared/helpers/posthog'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY || ''} options={postHogOptions}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
)
